import React from "react";
import LeafledMap from "../components/Map/leaflet-map";
import { PositionProvider } from "../context/position";


function Map() {
  return (
    <PositionProvider>
        <LeafledMap />
        
    </PositionProvider>
  );
}


export default Map;